import { callApiToServer } from "../callApi";

export async function deleteCharityProgram(authtoken, charityProgramId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      charityProgramId: charityProgramId,
    });

    let endUrl = "v1/auth/charity-program";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "DELETE", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
